import React from 'react'

const StockAdjustments = () => {
  return (
    <>
      <div className="pagetitle">
        <h1>Stock Adjustments</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item">Stock Management</li>
            <li className="breadcrumb-item active">Stock Adjustments</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Stock Adjustments</h5>
                <p>Stock adjustments content will be displayed here.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default StockAdjustments

